import isDesktop from '@lib/is-desktop';
import _throttle from 'lodash/throttle';

function initFullwidthTilesTeaserTile(root: HTMLDivElement): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const collapsible = root.querySelector<HTMLDivElement>('.fullwidth-tiles-teaser-tile__collapsible')!;
    if (!collapsible) return;

    let initialHeight = 0;
    setInitialHeight();

    root.addEventListener('mouseenter', expand);
    root.addEventListener('mouseleave', collapse);
    window.addEventListener('resize', _throttle(setInitialHeight, 300, { trailing: true, leading: false }), {
        passive: true,
    });

    function setInitialHeight() {
        collapsible.style.height = 'auto';
        initialHeight = collapsible.offsetHeight;
        collapse();
    }
    function collapse() {
        collapsible.style.height = isDesktop() ? '0px' : 'auto';
    }
    function expand() {
        collapsible.style.height = isDesktop() ? initialHeight + 'px' : 'auto';
    }
}

window.Drupal.behaviors['fullwidthTilesTeaser'] = {
    attach(context: Document | HTMLElement, settings: DrupalSettings) {
        context.querySelectorAll<HTMLDivElement>('.fullwidth-tiles-teaser-tile').forEach(initFullwidthTilesTeaserTile);
    },
};
